import { useCallback } from "react";

export const getOptionTitle = (option) => {
  let name = option.name || "";

  if (option.product) {
    name = option.product?.art_des_cmpy;
  }

  if (option.system) {
    name = option.system?.ciclo;
  }

  if (option.title) {
    name = option.title;
  }

  return name;
}

const useGetOptionTitle = () => {
  const fn = useCallback(getOptionTitle, []);
  return fn;
};

export default useGetOptionTitle;
